// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none{display:none}.sf-divider{display:block;display:var(--divider-display,block);margin:var(--divider-margin);max-width:var(--divider-max-width);width:var(--divider-width);border:var(--divider-border,var(--divider-border-style,solid) var(--divider-border-color,var(--c-light)));border-width:1px;border-width:var(--divider-border-width,1px)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
